import { currency } from 'helpers/format';
import { calculatePrice } from 'helpers/vehicle';

const PriceTable = ({ vehicle, children, showTotal, promotion, usdRate }) => (
  <div className="priceTable">
    <div className="priceTable__row">
      <div className="priceTable__item">Precio de lista</div>
      <div className="priceTable__price">{currency(vehicle.price, vehicle.currency)}</div>
    </div>
    <div className="priceTable__row">
      <div className="priceTable__item">Patentamiento</div>
      <div className="priceTable__price">{currency(vehicle.license_cost, vehicle.currency)}</div>
    </div>
    <div className="priceTable__row">
      <div className="priceTable__item">Entrega</div>
      <div className="priceTable__price">
        {currency(vehicle.preparation_cost, vehicle.currency)}
      </div>
    </div>
    {vehicle.currency === 'usd' && usdRate != null && (
      <div className="priceTable__row">
        <div className="priceTable__item">Cotización USD</div>
        <div className="priceTable__price">
          {currency(usdRate, 'ars')}
        </div>
      </div>
    )}
    {vehicle.special_discount === '0' && vehicle.web_discount > 0 && (
      <div className="priceTable__row">
        <div className="priceTable__item">Descuento web</div>
        <div className="priceTable__price">
          -{currency(vehicle.web_discount, vehicle.currency)}
        </div>
      </div>
    )}
    {vehicle.special_discount > 0 && (
      <div className="priceTable__row">
        <div className="priceTable__item">Descuento especial</div>
        <div className="priceTable__price">
          -{currency(vehicle.special_discount, vehicle.currency)}
        </div>
      </div>
    )}
    {vehicle.model_year_discount > 0 && (
      <div className="priceTable__row">
        <div className="priceTable__item">Descuento por MY</div>
        <div className="priceTable__price">
          -{currency(vehicle.model_year_discount, vehicle.currency)}
        </div>
      </div>
    )}
    {promotion && (
      <div className="priceTable__row">
        <div className="priceTable__item">Código de descuento</div>
        <div className="priceTable__price">
          -
          {promotion.money_discount > 0
            ? currency(promotion.money_discount, vehicle.currency)
            : currency((vehicle.price * promotion.percentage_discount) / 100, vehicle.currency)}
        </div>
      </div>
    )}
    {showTotal && (
      <div className="priceTable__row">
        <div className="priceTable__item">Total</div>
        <div className="priceTable__price">
          {currency(calculatePrice(vehicle, promotion), vehicle.currency)}
        </div>
      </div>
    )}
    {children}
  </div>
);

export default PriceTable;